// extracted by mini-css-extract-plugin
module.exports = {"marathonCard":"card-module--marathon-card--1LQd-","date":"card-module--date--3w8xN","title":"card-module--title--2CvWG","article":"card-module--article--SBA31"};